import React, { useLayoutEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const Login: React.FC = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect({
        // Restored by Auth0ProviderWithHistory once the login round trip is done.
        appState: {
          returnTo: window.location.pathname + window.location.search,
        },
      }).catch((err) => {
        // Swallow redirect-init failures so they don't surface as an
        // unhandled promise rejection in the dev error overlay.
        console.error('Auth0 loginWithRedirect failed', err);
      });
    }
  }, [isAuthenticated, loginWithRedirect]);

  return null;
};
export default Login;
